import Image from 'next/image';
import styles from './AssessmentReport.module.css';
import { useAssessmentContext } from '@/libs/context/AssessmentContext';
export function AssessmentStart() {
    const { setFormIndex } = useAssessmentContext();
    return (
        <div className={`${styles.get_startAssessment} mt30 mb50`}>
            <div className="container">
                <div className={styles.main_assessmentHey}>
                    <div className={styles.heading_assesment}>
                        <div className={styles.head_warp}>
                            <h3 className="font30 fontsm18 text000">Don&apos;t Guess, Assess! <Image src="/assets/images/hand.png" alt="Hello" width={40} height={40} className={styles.handIcon} /></h3>
                            <p className="font20 fontThin text000 fontsm16">Take a self-assessment for accurate diagnosis </p>
                        </div>
                        <div className={`${styles.Mint} textcenter`}>
                            <h4 className="font30 fontsm20 textfff lineHeight20">2-3 <span className="font14 fontThin">Minutes</span></h4>
                        </div>
                    </div>
                    <div className={`${styles.pointer_assessment} mt30 mb30`}>
                        <div className={styles.img_boxAssess}>
                            <Image src="/assets/images/assessment-start.png" height={336} width={170} alt="assessment-start" />
                        </div>
                        <div className={styles.assessmentList}>
                            <ul>
                                <li className="font16 fontRegular"><Image src="/assets/images/check-circle.png" height={30} width={30} alt="check" />Discreet, 100% online consultation</li>
                                <li className="font16 fontRegular"><Image src="/assets/images/check-circle.png" height={30} width={30} alt="check" />Know the root cause for better outcomes</li>
                                <li className="font16 fontRegular"><Image src="/assets/images/check-circle.png" height={30} width={30} alt="check" />Get your detailed assessment report along with doctor consultation </li>
                                <li className="font16 fontRegular"><Image src="/assets/images/check-circle.png" height={30} width={30} alt="check" />Evidence-based personalised treatments formulated by doctors</li>
                            </ul>
                            <div className={styles.callto_assessment}>
                                <button className={`${styles.btn} ${styles.btn_primary} btn btn-primary ${styles.buy_now_btn} font16 font600`} onClick={() => setFormIndex!(1)}>Start Assessment</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}